import MassProductItem from "@/components/MassProducts/MassProductItem/MassProductItem";
import {FileModel} from "@renta-apps/athenaeum-toolkit";
import ReturnedMassProduct from "@/models/server/ReturnedMassProduct";
import RentaToolsController from "@/pages/RentaToolsController";
import styles from "./ReturnedMassProductStep.module.scss";
import {Checkbox, Icon, IconSize, InlineType, Modal} from "@renta-apps/athenaeum-react-components";
import React, {useRef, useState} from "react";
import FileService from "@/services/FileService";
import Show from "@/components/Show/Show";
import CheckItem from "@/pages/Models/CheckItem";
import {
    ReturnedMassProductStepTypes
} from "./ReturnedMassProductStep.types";
import {MassProductStepDescription} from "@/pages/ReturnedMassProductPage/components";
import Localizer from "@/localization/Localizer";
import ToolsUtility from "@/helpers/ToolsUtility";

const ReturnedMassProductStep = ({ index, preview } : ReturnedMassProductStepTypes) => {
    const [pictures, setPictures] = useState<FileModel[]>([]);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [comment, setComment] = useState<string>("");
    const ref  = useRef<Modal>(null);

    const getReport = () => {
        if(!RentaToolsController.report) {
            throw new Error("Report is not set");
        }
        return RentaToolsController.report;
    }

    const getMassProduct = () => {
        const massProduct = getReport().items[index].massProduct;
        if(!massProduct){
            throw new Error("Mass product is not set");
        }

        return massProduct;
    }

    const getReportItem = () => {
        const item = getReport().items[index];
        if(!item){
            throw new Error("Report item is not set");
        }
        return item;
    }

    const onChangeMassProduct = (massProduct : ReturnedMassProduct) => {
        getReport().items[index].massProduct = massProduct;

        RentaToolsController.saveContext();
    }

    const checkBoxChange = (checkIndex : number, value : boolean) => {
        const checks = getReport().items[index]?.checks;
        if (checks) {
            checks[checkIndex].ok = value;
            RentaToolsController.saveContext();
        }
    }

    const onImageUpload = async (picture : FileModel) => {
        return await FileService.uploadFullImageAsync(picture);
    }

    const onQuestionIconClick = (check : CheckItem) => {
        setPictures(check.pictures || []);
        setIsModalOpen(true);
        setComment(check.comment || "");
        ref.current?.openAsync();
    }

    const onModalClose = () => {
        ref.current?.closeAsync();
    }

    return (
        <div>
            <Show.When isTrue={isModalOpen}>
                <MassProductStepDescription description={comment} onModalClose={onModalClose} pictures={pictures} modalRef={ref} />
            </Show.When>

            <div className={styles.checks}>
                {
                    getReportItem().checks?.map((check, index) => (
                        <div className={styles.checkRow}>
                            <Checkbox inline
                                      readonly={preview}
                                      id={`check_${index}`}
                                      disabled={preview}
                                      label={check.name}
                                      className={styles.checkbox}
                                      inlineType={InlineType.Right}
                                      value={check.ok}
                                      onChange={async (sender, value) => checkBoxChange(index, value)}
                            />

                            <div className={styles.questionIconContainer} onClick={() => onQuestionIconClick(check)}>
                                <Show.When isTrue={ToolsUtility.isNullOrEmpty(check.comment)}>
                                    <Icon name={"fal fa-question-square"} size={IconSize.X2} className={styles.questionIcon} />
                                </Show.When>
                            </div>
                        </div>
                    ))
                }
            </div>

            <div className={styles.title}>
                <span>{Localizer.returnedMassProductSelectAmount}</span>
            </div>

            <MassProductItem preview={preview}
                             massProduct={getMassProduct()}
                             onChange={async (massProduct : ReturnedMassProduct) => onChangeMassProduct(massProduct)}
                             onImageUpload={async (picture : FileModel) => onImageUpload(picture)}
            />
        </div>
    )
}

export default ReturnedMassProductStep;